import { render, staticRenderFns } from "./AddBodyMeasurement.vue?vue&type=template&id=2d046434&scoped=true"
import script from "./AddBodyMeasurement.vue?vue&type=script&lang=js"
export * from "./AddBodyMeasurement.vue?vue&type=script&lang=js"
import style0 from "./AddBodyMeasurement.vue?vue&type=style&index=0&id=2d046434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d046434",
  null
  
)

export default component.exports